import { render, staticRenderFns } from "./DirPad.vue?vue&type=template&id=2391114c&scoped=true"
import script from "./DirPad.vue?vue&type=script&lang=js"
export * from "./DirPad.vue?vue&type=script&lang=js"
import style0 from "./DirPad.vue?vue&type=style&index=0&id=2391114c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2391114c",
  null
  
)

export default component.exports